import { post } from '@/http'

//  我的优惠券列表
export function getList(data) {
    return new Promise((resolve, reject) => {
        post('/Discount/GetList', data)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
